export const TEXT_FIELD = 1;
export const CHECKBOX_FIELD = 2;
export const RADIO_FIELD = 3;
export const COMPOUND_RADIO = 4;
export const SCORE_FIELD = 5;
export const DATETIME_FIELD = 6;
export const NUMERIC_FIELD = 7;
export const JSON_FIELD = 8;
